import { useState } from "react";
import { selectedCompanyId } from "../../lib/api";
import { useAuth } from "../../stores/auth";
import { readMatrixView, type FinanceOrigin } from "../../features/eex/finance-navigation";
import { MonthlyPnlMatrix } from "./MonthlyPnlMatrix";
import { FinanceComparisonMatrix } from "./FinanceComparisonMatrix";

/** Preserve the EUR reporting/forecast matrix while making portfolio review the default. */
export function PortfolioMatrixWorkspace({ active, financeOrigin = {} }: { active: boolean; financeOrigin?: FinanceOrigin }) {
  const user = useAuth(state => state.user);
  const companyId = selectedCompanyId() ?? user?.companyId ?? null;
  const [mode, setMode] = useState(() => {
    const saved = readMatrixView(financeOrigin, companyId);
    return saved && !saved.comparison ? "forecast" : "portfolio";
  });
  return <div className="portfolio-matrix-workspace">
    <div className="fin-presets fc-basis-switch" role="group" aria-label="Matrix reporting basis">
      <button type="button" aria-pressed={mode === "portfolio"} onClick={() => setMode("portfolio")}>P&L, VM & carry</button>
      <button type="button" aria-pressed={mode === "forecast"} onClick={() => setMode("forecast")}>EUR P&L & forecasts</button>
    </div>
    {mode === "portfolio" ? <FinanceComparisonMatrix key={companyId} active={active} financeOrigin={financeOrigin} />
      : <MonthlyPnlMatrix key={companyId} active={active} financeOrigin={financeOrigin} />}
  </div>;
}
